module.exports = __webpack_public_path__ + "img/English.856caf35.jpg";